export const CANONICAL_SERIES_NAME = "the great (un)lock-in.";

const SERIES_VARIANTS = /(?:the\s+)?great\s+(?:\(un\)\s*lock[- ]?in|unlockin(?:g)?|unlock[- ]?in)(?:\.)?/gi;

export function canonicalizeBrandText(value) {
  if (typeof value !== "string") return value;
  return value.replace(SERIES_VARIANTS, CANONICAL_SERIES_NAME);
}

export function findProjectForOutcome(projects, outcomeId, outcomeTitle) {
  return (projects || []).find(project =>
    (outcomeId && String(project.outcomeId || "") === String(outcomeId)) ||
    (outcomeTitle && canonicalizeBrandText(project.outcomeTitle || "").toLowerCase() === canonicalizeBrandText(outcomeTitle).toLowerCase())
  );
}

export function activeRecord(record) {
  return !["done", "archived", "complete", "completed", "superseded", "replaced"].includes(String(record?.status || "").toLowerCase());
}
